import { Badge, Box, Button, Group, Text, Tooltip } from "@mantine/core";

const Indicator = () => (
    <Box
        sx={(theme) => ({
            position: 'absolute',
            top: -2,
            right: -2,
            width: 8,
            height: 8,
            borderRadius: '50%',
            zIndex:0,
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.lime[4] : theme.colors.lime[6],
            border: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white}`,
        })}
    />
);

export const CountDisplay = ({ val, icon, tooltip, onClick, theme, hasIndicator }) => {
    const content = (
        <Box style={{ position: 'relative' }}>            
            {val && parseInt(val) ? (
                <Button
                    onClick={onClick}
                    variant='gradient'
                    sx={{ fontSize: 11, height: 20, paddingTop: 0, paddingBottom: 0, lineHeight: 18, letterSpacing: 0.25, paddingLeft: 5, paddingRight: 5, width: 70 }}
                    radius={'xl'}
                    size='xs'
                    gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }}>
                    {/* <Badge variant="gradient" gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }}> */}
                    <Group spacing={4}>
                        {icon}
                        <Text size={'sm'}>{val}</Text>
                    </Group>
                    {/* </Badge> */}
                </Button>
            ) : (
                <Badge color={val && val > 0 ? 'brand' : theme.colorScheme} sx={{ paddingTop: 11, paddingBottom: 11, width: 70 }}>
                    <Group spacing={4}>
                        {icon}
                        <Text color='dimmed' size={'sm'}>
                            0
                        </Text>
                    </Group>
                </Badge>
            )}
            {hasIndicator ? <Indicator /> : null}
        </Box>
    );

    return tooltip ? <Tooltip label={tooltip}>{content}</Tooltip> : content;
};
